import React from 'react';

const MenuContext = React.createContext(null);

export const MenuProvider = MenuContext.Provider;

export default MenuContext;